// Loader first-party do Google Tag Manager (container GTM-5HR3JDLW).
//
// Serve o container pelo proxy no domínio da casa em vez de
// `googletagmanager.com`, então ad blocker e ITP não barram a requisição.
//
// Fica no topo do `head`, renderizado no SSR (`tagPriority` negativo, ver
// abaixo), para que o `dataLayer` já exista antes de qualquer evento da
// aplicação. É o único caminho de carga do container: o antigo, no plugin
// `03-asyncLoad`, só subia o container 8–16s depois da hidratação, e os
// eventos disparados nesse intervalo eram descartados por
// `shared/Metrics/handlers/gtm.ts` (`if (!window.dataLayer) return;`).
//
// O script é injetado por JS (`document.createElement`), logo o preload
// scanner do browser não enxerga a URL: a conexão com `aptdo.apostatudo.bet.br`
// é aberta pelo `preconnect` em `_config/linktags.ts`.
//
// Gate do app nativo (ENG-397 / App Store 5.1.1(iv)): dentro da WebView nenhum
// tracker de site roda. É a mesma checagem de `isRunningInNativeApp`
// (`utils/browserInfo.ts`), repetida aqui em ES5 porque este trecho vai cru no
// HTML, sem passar pelo build. O `react-native-webview` injeta
// `window.ReactNativeWebView` antes do JS da página, então o gate é síncrono e
// não há corrida de timing.
const gtmFirstPartyLoader = `
if (!window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== 'function') {
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://aptdo.apostatudo.bet.br/ftxgqluyu.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','ag11=HB1IKyUqVUE9K0YmNSsvUgNER0JAQRwaSBgFAwITGQAAHRpCEwIMWhcL');
}
`;

export const scriptsHead = [
  // {
  //   src: 'https://site.com/script.js',
  //   defer: true,
  //   async: true,
  //   hid: 'script-id',
  // },
  {
    innerHTML: gtmFirstPartyLoader,
    // Script inline sem `src` pesa 100 no Unhead, o que o jogaria para o fim do
    // `head`. O valor numérico substitui o peso: -12 fica depois do `charset`
    // (-20) e do `viewport` (-15) — que precisam vir primeiro — e antes de todo
    // o resto (`base` -10, `title` 10, preconnect 20, CSS e demais scripts).
    tagPriority: -12,
  },
];
